import Amplify, { Storage } from 'aws-amplify';
import awsmobile from '../../aws-exports';
Amplify.configure(awsmobile);

const processStorageList = (results) => {
  const filesystem = {}
  // https://stackoverflow.com/questions/44759750/how-can-i-create-a-nested-object-representation-of-a-folder-structure
  const add = (source, target, item) => {
    const elements = source.split("/");
    const element = elements.shift();
    if (!element) return // blank
    target[element] = target[element] || { __data: item }// element;
    if (elements.length) {
      target[element] = typeof target[element] === "object" ? target[element] : {};
      add(elements.join("/"), target[element], item);
    }
  };
  results.forEach(item => add(item.key, filesystem, item));
  // console.log("processStorageList", filesystem)
  return filesystem
}

const processFlatStorageList = (response) => {
  let files = [];
  let folders = new Set();
  // console.log('processFlatStorageList', response)
  response.forEach(res => {
    if (res.size) {
      files.push(res);
      // sometimes files declare a folder with a / within then
      let possibleFolder = res.key
        .split('/')
        .slice(0, -1)
        .join('/');
      if (possibleFolder) folders.add(possibleFolder);
    } else {
      folders.add(res.key);
    }
  });
  return { files, folders };
}

// level: 'public', 'private', 'protected'
const s3ListObjects = async (directory = '', mylevel = 'public', callback) => {
  //  console.log('s3ListObject called with: directory=%s, level=%s', directory, mylevel)
  await Storage.list(directory, { level: mylevel }) // for listing ALL files without prefix, pass '' instead
    .then(result => callback(processStorageList(result)))
    .catch(err => console.log(err));
}

const s3ListFlatObjects = async (directory = '', mylevel = 'public', callback) => {
  //  console.log('s3ListObject called with: directory=%s, level=%s', directory, mylevel)
  await Storage.list(directory, { level: mylevel }) // for listing ALL files without prefix, pass '' instead
    .then(result => callback(processFlatStorageList(result)))
    .catch(err => console.log(err));
}

const s3ReadFile = async (filename, level, callback) => {
  const result = await Storage.get(filename, { level: level, download: true, cacheControl: "no-cache", });

  // data.Body is a Blob
  result.Body.text().then(string => {
    // handle the String data return String 
    // console.log('s3ReadFile called: ', filename, string)
    const obj = JSON.parse(string)
    // console.log('s3ReadFile returned: ' + string)
    callback(obj)
    //    return obj
  });
}

const s3ReadJsonArray = async (filename, level, callback) => {
  try {
    const result = await Storage.get(filename, {
      level: level,
      download: true,
      cacheControl: "no-cache",
    });

    const string = await result.Body.text();
    let obj;

    try {
      obj = JSON.parse(string);
      if (!Array.isArray(obj)) {
        console.warn(`Datei ${filename} enthält kein Array - Rückgabe: []`);
        obj = [];
      }
    } catch (parseError) {
      obj = [];
    }

    callback(obj);
  } catch (err) {
    if (err.response?.status === 404 || err.name === "NoSuchKey") {
      console.info(`Datei ${filename} existiert nicht -  Rückgabe: []`);
      callback([]);
    } else {
      console.error(`Fehler beim Lesen von ${filename}:`, err);
      throw err;
    }
  }
}

const s3WriteFile = async (fn, content, level = "private", type = "text/plain", cache = "no-cache") => {
  console.log('s3WriteFile called with', fn, content)
  const { key } = await Storage.put(fn, content, {
    level: level,
    contentType: type,
    CacheControl: cache,
  });
  //.then (result => console.log(result))
  //.catch(err => console.log(err));
  return {
    fn,
    fileKey: key
  }
}

const s3AppendJsonArray = async (fn, newItem, level = "private") => {
  try {
    let jsonArray = [];

    // 1. Datei lesen (falls vorhanden)
    try {
      const response = await Storage.get(fn, { level: level, download: true, cacheControl: "no-cache", });
      const text = await response.Body.text();
      jsonArray = JSON.parse(text);
      if (!Array.isArray(jsonArray)) {
        console.warn("Dateiinhalt ist kein Array und wird überschrieben.");
        jsonArray = [];
      }
    } catch (err) {
      if ((err.response && err.response.status === 404) || err.name === "NoSuchKey") {
        // Datei existiert nicht – neues Array
        jsonArray = [];
      } else {
        throw err;
      }
    }

    // 2. Neuen Eintrag anhängen
    jsonArray.push(newItem);

    // 3. Datei mit vollständigem Array wieder speichern
    const { key } = await Storage.put(fn, JSON.stringify(jsonArray, null, 2), {
      level: level,
      contentType: "application/json",
      CacheControl: "no-cache",
    });

    return { fn, fileKey: key };
  } catch (error) {
    console.error("Fehler beim Schreiben von JSON-Array:", error);
    throw error;
  }
}

const s3DeleteFile = async (fn, mylevel = 'private') => {
  // console.log('s3Delete:', '\'' + fn + '\'', mylevel)
  await Storage.remove(fn, { level: mylevel });
}

const s3GenDownloadLink = async (fileKey) => {
  const result = await Storage.get(fileKey, { download: true });
  return s3DownloadBlob(result.Body, fileKey);
}

const s3DownloadBlob = async (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.split('/').pop() || 'download';
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener('click', clickHandler);
    }, 150);
  };
  a.addEventListener('click', clickHandler, false);
  a.click();
  return a;
}

export {
  s3ListObjects,
  s3ListFlatObjects,
  s3ReadFile,
  s3WriteFile,
  s3AppendJsonArray,
  s3DeleteFile,
  s3GenDownloadLink,
  s3ReadJsonArray
}